
export function isBrowserLoaded() {
  return document.readyState === 'complete' || document.readyState === 'interactive';
}



// WEBPACK FOOTER //
// ./assets/utilities/browser.js